import React from 'react';
import { useRoom } from '../context/RoomContext';
import './ParticipantsList.css';

const ParticipantsList = ({ isOpen, onClose }) => {
  const { participants, socketId } = useRoom();

  if (!isOpen) return null;

  return (
    <div className="participants-panel">
      <div className="participants-header">
        <h3>Participants ({participants.length})</h3>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      </div>

      <div className="participants-list">
        {participants.map((participant, index) => (
          <div key={participant.id || participant.socketId || index} className="participant-item">
            <div className="participant-avatar">
              {participant.name?.charAt(0)?.toUpperCase() || '?'}
            </div>
<div className="participant-info">
              <span className="participant-name">
                {participant.name || 'Utilisateur'}
                {participant.id === socketId && ' (Toi)'}
              </span>
              {participant.isHost && (
                <span className="host-badge">Hôte</span>
              )}
            </div>
            <div className="participant-status">
              {participant.isMuted && (
                <span className="status-icon" title="Muted">🔇</span>
              )}
              {participant.isVideoOff && (
                <span className="status-icon" title="Video Off">📷</span>
              )}
              {participant.handRaised && (
                <span className="status-icon hand-raised-icon" title="Hand Raised">✋</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ParticipantsList;
